import { API_ROUTE_ADMIN_TEXT_TEMPLATES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { TextTemplateTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getTextTemplateList = () =>
  get<TextTemplateTypeOriginal[]>(API_ROUTE_ADMIN_TEXT_TEMPLATES, IS_NEW_BACKEND_API)
